import { createFileRoute } from '@tanstack/react-router'
import { AcceptInvitationScreen } from '@/features/auth/routes/accept-invitation-screen'

export const Route = createFileRoute('/accept-invitation/$id')({
  component: AcceptInvitationScreen,
})
